/**
 * EmbedLayout
 * Minimal layout used when the app runs inside an iframe/webview.
 * No Header, no Sidebar — just the flow content with minimal padding.
 */

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import FullScreenLoader from "@components/FullScreenLoader";

const EmbedRoot = styled(Box, {
  name: "embed-root",
  slot: "root"
})({
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  width: "100vw",
  overflow: "auto"
});

const EmbedLayout: React.FC = () => {
  return (
    <EmbedRoot role="main" id="main-content">
      <Suspense fallback={<FullScreenLoader />}>
        <Outlet />
      </Suspense>
    </EmbedRoot>
  );
};

export default EmbedLayout;
